var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SectionHeader", {
    attrs: {
      "show-content": _vm.dynamicInboundCallsSettingsShowContents,
      "widget-title": _vm.$t("HEADER_DYNAMIC_INBOUND_CALLS")
    },
    on: {
      onShowContentsClick: _vm.onDynamicInboundCallsSettingsShowContentsClick
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "form",
              {
                staticClass: "form-horizontal",
                attrs: { role: "form", name: "dynamicInboundCallsSettings" }
              },
              [
                _vm.affiliateView && !_vm.isPublisherGroupUser
                  ? _c(
                      "div",
                      { staticClass: "p-t-2 p-b-10" },
                      [
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("LABEL_ID"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("TOOLTIP_ID")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-sm-6 col-md-4 p-t-2 p-b-10"
                                      },
                                      [
                                        _c("p", [
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "clipboard",
                                                  rawName: "v-clipboard",
                                                  value: {
                                                    copyText:
                                                      _vm.affiliateViewRtbId
                                                  },
                                                  expression:
                                                    "{ copyText: affiliateViewRtbId }"
                                                }
                                              ],
                                              staticClass:
                                                "btn btn-link p-l-0 p-r-5"
                                            },
                                            [
                                              _c("i", {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip.right",
                                                    value: _vm.$t(
                                                      "TOOLTIP_COPY_BUTTON_ID"
                                                    ),
                                                    expression:
                                                      "$t('TOOLTIP_COPY_BUTTON_ID')",
                                                    modifiers: { right: true }
                                                  }
                                                ],
                                                staticClass:
                                                  "typcn typcn-tabs-outline",
                                                attrs: { "aria-hidden": "true" }
                                              })
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.affiliateViewRtbId) +
                                              "\n              "
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            2795373696
                          )
                        }),
                        _vm._v(" "),
                        _vm.enabled
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t("LABEL_DOCUMENTATION"),
                                "hide-label": false,
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t("TOOLTIP_DOCUMENTATION")
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-sm-6 col-md-4 p-t-2 p-b-10"
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn btn-primary",
                                                attrs: {
                                                  type: "button",
                                                  "data-cy":
                                                    "button-view-documentation"
                                                },
                                                on: {
                                                  click:
                                                    _vm.openDynamicInboundCallsDocumentationModal
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "TOOLTIP_DOCUMENTATION"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.affiliate
                                              .showDynamicInboundCallsDocumentationModal
                                              ? _c("DocumentationModal", {
                                                  attrs: {
                                                    "campaign-id":
                                                      _vm.campaignId,
                                                    affiliate: _vm.affiliate,
                                                    "rtb-id":
                                                      _vm.affiliateViewRtbId,
                                                    "on-close-modal":
                                                      _vm.closeDynamicInboundCallsDocumentationModal
                                                  }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                537088283
                              )
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.overridesAvailable ||
                _vm.overrideDynamicInboundCallsSettings
                  ? _c(
                      "div",
                      [
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("LABEL_ENABLED"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("TOOLTIP_ENABLED")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "ValidationProvider",
                                      {
                                        attrs: { rules: "required", slim: "" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-3 col-sm-2 col-md-2 col-lg-2 toggle-wrap"
                                          },
                                          [
                                            _c("nzToggle", {
                                              attrs: {
                                                disabled: _vm.affiliateView,
                                                "data-cy": "rtb-enabled-toggle"
                                              },
                                              on: {
                                                onToggle: _vm.enabledToggle
                                              },
                                              model: {
                                                value: _vm.enabled,
                                                callback: function($$v) {
                                                  _vm.enabled = $$v
                                                },
                                                expression: "enabled"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1686659930
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.enabled && !_vm.overridesAvailable
                  ? _c(
                      "div",
                      [
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("LABEL_ONLY_SIP"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("TOOLTIP_ONLY_SIP")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "ValidationProvider",
                                      {
                                        attrs: { rules: "required", slim: "" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-3 col-sm-2 col-md-2 col-lg-2 toggle-wrap"
                                          },
                                          [
                                            _c("nzToggle", {
                                              attrs: {
                                                disabled: _vm.affiliateView
                                              },
                                              on: {
                                                onToggle: _vm.onlySIPToggle
                                              },
                                              model: {
                                                value: _vm.sipOnly,
                                                callback: function($$v) {
                                                  _vm.sipOnly = $$v
                                                },
                                                expression: "sipOnly"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3968737368
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.enabled
                  ? _c("Field", {
                      attrs: {
                        label: _vm.$t("LABEL_REQUIRE_CALLER_ID"),
                        "hide-label": false,
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("TOOLTIP_REQUIRE_CALLER_ID")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "ValidationProvider",
                                  { attrs: { rules: "required", slim: "" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-3 col-sm-2 col-md-2 col-lg-2 toggle-wrap"
                                      },
                                      [
                                        _c("nzToggle", {
                                          attrs: {
                                            disabled: _vm.affiliateView
                                          },
                                          on: {
                                            onToggle: _vm.callerIdRequiredToggle
                                          },
                                          model: {
                                            value: _vm.callerIdRequired,
                                            callback: function($$v) {
                                              _vm.callerIdRequired = $$v
                                            },
                                            expression: "callerIdRequired"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3262085720
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showPayoutSettings && _vm.enabled
                  ? _c("PayoutSettings", {
                      attrs: {
                        enableCapsLabel: _vm.$t("LIMIT_RTB_PAYOUT_LABEL"),
                        enableCapsTooltip: _vm.$t("TOOLTIP_LIMIT_PAYOUT"),
                        translactionDictionary:
                          _vm.publisherPayoutCapFieldsTranslaction,
                        "payout-capacity": _vm.payoutCapacity,
                        "call-caps": _vm.callCaps,
                        "affiliate-view": _vm.affiliateView
                      },
                      on: {
                        "change-call-caps": _vm.onCallCapsChange,
                        "change-publisher-payout-capacity":
                          _vm.onPayoutCapsChange
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isIcpVisible
                  ? _c(
                      "div",
                      [
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("LABEL_ICP"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("TOOLTIP_ICP")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "ValidationProvider",
                                      {
                                        attrs: { rules: "required", slim: "" }
                                      },
                                      [
                                        _c("MultipleToggle", {
                                          attrs: {
                                            value: _vm.icp,
                                            options: _vm.icpOptions,
                                            disabled: _vm.affiliateView
                                          },
                                          on: { onToggle: _vm.onIcpChange }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            4192193859
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isJornayaVisible
                  ? _c(
                      "div",
                      [
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("LABEL_JORNAYA_TCPA"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("TOOLTIP_JORNAYA_TCPA")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "ValidationProvider",
                                      {
                                        attrs: { rules: "required", slim: "" }
                                      },
                                      [
                                        _c("MultipleToggle", {
                                          attrs: {
                                            value: _vm.journayaTcpa,
                                            options: _vm.journayaTcpaOptions,
                                            disabled: _vm.affiliateView
                                          },
                                          on: {
                                            onToggle: _vm.onJournayaTcpaChange
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1390085962
                          )
                        }),
                        _vm._v(" "),
                        _vm.journayaTcpa != "Off"
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t("LABEL_JORNAYA_CREDENTIALS"),
                                "hide-label": false,
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t(
                                  "TOOLTIP_JORNAYA_CREDENTIALS"
                                )
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c(
                                          "ValidationProvider",
                                          {
                                            attrs: {
                                              rules: "required",
                                              slim: ""
                                            }
                                          },
                                          [
                                            _c("MultipleToggleOverride", {
                                              attrs: {
                                                "toggle-name":
                                                  "jornayaSettings",
                                                value:
                                                  _vm.overrideJornayaSettings,
                                                options:
                                                  _vm.jornayaOverrideOptions,
                                                disabled: _vm.affiliateView
                                              },
                                              on: {
                                                onToggle:
                                                  _vm.overrideJornayaSettingsToggle
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                4069904167
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.journayaTcpa != "Off" &&
                        _vm.isJornayaSettingsVisible
                          ? _c(
                              "div",
                              [
                                _c("JornayaSettings", {
                                  attrs: {
                                    "jornaya-setting": _vm.jornayaSettings
                                  },
                                  on: {
                                    jornayaSettingsChange:
                                      _vm.onJornayaSettingsChange
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isTrustedFormVisible
                  ? _c(
                      "div",
                      [
                        _c("Field", {
                          attrs: {
                            label: _vm.$t("LABEL_TRUSTED_FORM"),
                            "hide-label": false,
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("TOOLTIP_TRUSTED_FORM")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "ValidationProvider",
                                      {
                                        attrs: { rules: "required", slim: "" }
                                      },
                                      [
                                        _c("MultipleToggle", {
                                          attrs: {
                                            value: _vm.trustedForm,
                                            options: _vm.trustedFormOptions,
                                            disabled: _vm.affiliateView
                                          },
                                          on: {
                                            onToggle: _vm.onTrustedFormChange
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            2394208570
                          )
                        }),
                        _vm._v(" "),
                        _vm.trustedForm != "Off"
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t("LABEL_TRUSTED_FORM_METHOD"),
                                "hide-label": false,
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t(
                                  "TOOLTIP_TRUSTED_FORM_METHOD"
                                )
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c(
                                          "ValidationProvider",
                                          {
                                            attrs: {
                                              rules: "required",
                                              slim: ""
                                            }
                                          },
                                          [
                                            _c("MultipleToggleOverride", {
                                              attrs: {
                                                value:
                                                  _vm.trustedFormIntegration
                                                    .integrationMethod,
                                                options:
                                                  _vm.trustedFormIntegrationOptions,
                                                disabled: _vm.affiliateView
                                              },
                                              on: {
                                                onToggle:
                                                  _vm.onTrustedFormIntegrationChange
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                1379913567
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.trustedForm != "Off"
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t("LABEL_OVERRIDE_TRUSTED_FORM"),
                                "hide-label": false,
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t(
                                  "TOOLTIP_OVERRIDE_TRUSTED_FORM"
                                )
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c(
                                          "ValidationProvider",
                                          {
                                            attrs: {
                                              rules: "required",
                                              slim: ""
                                            }
                                          },
                                          [
                                            _c("MultipleToggleOverride", {
                                              attrs: {
                                                "toggle-name":
                                                  "trustedFormSettings",
                                                value:
                                                  _vm.overrideTrustedFormSettings,
                                                options:
                                                  _vm.trustedFormOverrideOptions,
                                                disabled: _vm.affiliateView
                                              },
                                              on: {
                                                onToggle:
                                                  _vm.overrideTrustedFormSettingsToggle
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                4115418631
                              )
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.trustedForm != "Off" &&
                        _vm.isTrustedFormSettingsVisible
                          ? _c(
                              "div",
                              [
                                _c("TrustedFormSettings", {
                                  attrs: {
                                    "trusted-form-setting":
                                      _vm.trustedFormSettings
                                  },
                                  on: {
                                    trustedFormSettingsChange:
                                      _vm.onTrustedFormSettingsChange
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.showIcpConfirmationModal
              ? _c("IcpConfirmationModal", {
                  attrs: {
                    "is-loading-data": _vm.isLoadingPricingPlan,
                    "pricing-plan": _vm.pricingPlan
                  },
                  on: { onConfirmIcpPricing: _vm.onConfirmIcpPricing }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }